"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AprPricingRateType = void 0;
/** @TranslateToPython @TranslateToEnum */
var AprPricingRateType;
(function (AprPricingRateType) {
    AprPricingRateType["revolving"] = "revolving";
    AprPricingRateType["fixedTerm"] = "fixedTerm";
    AprPricingRateType["fixedInterestOnly"] = "fixedInterestOnly";
})(AprPricingRateType || (exports.AprPricingRateType = AprPricingRateType = {}));
